import { render, staticRenderFns } from "./LimiteCreditoCadastroModal.vue?vue&type=template&id=2909c195&scoped=true"
import script from "./LimiteCreditoCadastroModal.vue?vue&type=script&lang=js"
export * from "./LimiteCreditoCadastroModal.vue?vue&type=script&lang=js"
import style0 from "./LimiteCreditoCadastroModal.vue?vue&type=style&index=0&id=2909c195&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2909c195",
  null
  
)

export default component.exports